import { Box, MenuItem } from '@mui/material';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';

interface OverlayMenuItemProps {
  isMobile: boolean;
  label: string;
  onMouseEnter: (content: string) => void;
  onMouseLeave: () => void;
  setSelectedOverlay: (text: string) => void;
}

export function OverlayMenuItem({
  isMobile,
  label,
  onMouseEnter,
  onMouseLeave,
  setSelectedOverlay,
}: OverlayMenuItemProps) {
  const value = label === 'None' ? '' : label;

  return (
    <MenuItem
      onMouseEnter={() =>
        !isMobile && label !== 'None' ? onMouseEnter(label) : null
      }
      onMouseLeave={onMouseLeave}
      value={value}
      sx={{
        borderTop: label !== 'None' ? '0.33px solid' : '',
        borderColor: '#E0E0E0',
      }}
      onClick={(e) => {
        e.preventDefault();
        setSelectedOverlay(value);
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
        }}
      >
        <div style={{ flex: 1, textTransform: 'uppercase' }}>{label}</div>
        {label !== 'None' && isMobile && (
          <div style={{ flex: 1, textAlign: 'right' }}>
            <Box
              style={{
                borderRadius: '50%',
                background: '#A6D5F5',
                width: '20px',
                height: '20px',
                display: 'inline-flex',
              }}
            >
              <PriorityHighIcon
                viewBox={'0 0 24 24'}
                style={{
                  width: '.8em',
                  height: '.8em',
                  marginTop: '1px',
                  marginLeft: '1px',
                }}
                sx={{ color: 'white' }}
              />
            </Box>
          </div>
        )}
      </div>
    </MenuItem>
  );
}
